<template>
  <PageContainer v-if="data" :breadcrumbs="breadcrumbs">
    <h1 class="pageHeader">ポケカ人気エクストラコレクションカード</h1>

    <div class="Body" v-if="data.pokemonSingleProducts.length">
      <SummaryList
        :items="data.pokemonSingleProducts"
        :disable-view-transition
      />
    </div>
  </PageContainer>
</template>

<script lang="ts">
import { definePageMeta, useSeoMeta, useHead, useRuntimeConfig } from '#imports'
import {
  defineNuxtComponent,
  useAsyncData,
  useNuxtApp,
  createError,
} from "#app";
import { DITokens } from "@/di";
import SummaryList from '@/components/Pokemon/Single/SummarList'
import PageContainer from '@/containers/Page'

export default defineNuxtComponent({
  components: {
    PageContainer,
    SummaryList
  },
  async setup() {
    const { public: { APP_ENV } } = useRuntimeConfig()

    definePageMeta({
      genre: 'pokemon',
      footer: {
        isShowSocialMedia: true,
        isShowShopSeries: true,
      }
    })

    const { $container } = useNuxtApp();
    const cartStore = $container.resolve(DITokens.CartStore);
    const cartState = storeToRefs(cartStore);
    const disableViewTransition = computed(() => cartState.showCart.value) // カート表示中はview transitionをoff

    const { data, error } = await useAsyncData(
      `pokemon_pickups_extra`,
      async () => {
        const { hits } = await $container.resolve(DITokens.ElasticsearchGateway).getPokemonSinglePickupExtraProducts({ sortType: 'default' })

        return {
          pokemonSingleProducts: hits,
        };
      }
    );

    if (error.value || !data.value) {
      throw createError({
        statusCode: 404,
        statusMessage: "Page not found",
      });
    }

    const title = '【ポケカ人気エクストラコレクションカード】 | ポケカ通販のカーナベル'
    const description = 'ポケモンカードのエクストラ人気カードを状態別に販売！激レアカードを豊富に取り揃え。「納得価格」「状態別販売」「即日発送」で、最短翌日午前中に手に入る。'
    const url = 'https://sell.ka-nabell.com/pokemon/pickups/extra'

    useSeoMeta({
      title,
      description,
      ogTitle: title,
      ogDescription: description,
      robots: APP_ENV === 'production' ? 'index,follow' : 'noindex,nofollow',
      twitterSite: '@ka_nabell_pcg',
      ogSiteName: 'ポケカ販売ならカーナベル！',
      ogUrl: url
    });

    useHead({
      link: [
        {
          rel: 'canonical',
          href: url
        }
      ]
    })

    // Set Breadcrumbs
    const breadcrumbs = [
      {
        title: 'トレカ販売トップ',
        link: '/',
      },
      {
        title: 'ポケカ販売トップ',
        link: '/pokemon',
      },
      {
        title: 'ポケカ人気エクストラコレクションカード',
      },
    ]

    return {
      data,
      breadcrumbs,
      disableViewTransition
    };
  },
});
</script>

<style scoped>
.Body {
  width: 100%;
  display: flex;
  column-gap: 16px;
  row-gap: 20px;
  flex-wrap: wrap;
}

.pageHeader {
  width: 100%;
}
</style>
